/// <reference path="./Basic.js" />
$(function($) {
  $.widget("ui.ipsRTLLayout", $.ui.ipsBasicLayout, {
    addControl: function(control, options) {
      var top = options.top;
      if (options.position == "absolute") {
        top = parseInt(options.top, 10) + 4;
      }
      control.css({
        position: options.position,
        right: options.left,
        top: top
      });
    },
    isRTL: function() {
      return true;
    },
    _calculateRightPosition: function(dim, node, scrollLeft) {
      var right;
      if (node.style.right) {
        right = parseInt(node.style.right, 10);
      } else {
        // trying to calculate the "offsetRight" on this node.
        // we do this by adding the offsetLeft and the width
        // we then take that minus the width to get the "right"
        right = dim.width - (node.offsetLeft + node.offsetWidth);
        // if it is negative then that means we have a situation where the width is greather than the screen size
        // in that case lets make the widht be the same as the scrensize
        if (right < 0) {
          right = 0;
        }
      }
      return right;
    },
    _calculateFirstNodeWidth: function(dim, node, scrollLeft) {
      var right = this._calculateRightPosition(dim, node, scrollLeft);
      return dim.width - right;
    },
    _getNodeLeftPosition: function(node, $node) {
      return Math.abs(node.offsetLeft) + node.offsetWidth;
    },
    _getNodeWidth: function(parent, position, parentPadding) {
      return position - parentPadding;
    },
    _getOffsetLeft: function(dim, node) {
      return this._calculateRightPosition(dim, node, 0);
    }
  });
});
